//import logo from './logo.svg';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import {NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CandidateRegister from './components/Candidate/Register/Candidate_Register';
import CandidateLogin from './components/Candidate/Login/Candidate_Login';
import Changepassword from './components/Candidate/Login/Change_password';
import CandidateDashboard from './components/Candidate/Dashboard/Candidate_Dashboard';
import CandidateCompanylist from './components/Candidate/Company_list/Candidate_Company_list';
import CandidateStatus from './components/Candidate/Status/Candidate_Status';
import CandidateProfile from './components/Candidate/Profile/Candidate_Profile';
import Volunteer_registration from './components/Volunteer/Volunteer_registration'
import Volunteer_login from './components/Volunteer/Volunteer_login'
import Edit_profile from './components/Volunteer/Edit_profile'
import Searchjob_seeker from './components/Search_details/Searchjob_seeker'
import Report_generation from './components/Search_details/Report_generation'
import ErrorPage from './components/Utils/Error_Page';

import Home_page from './components/Exam/Home_Page';
import Go_To_Exam from './components/Exam/Go_To_Exam';
import Start_Exam from './components/Exam/Start_Exam';
import Certificate from './components/Exam/Certificate';
import Validator from './components/Certificate_Verify/Validator'
import StudentRegistration from './components/Student_Registration/StudentRegistration';
import Registration_Success from './components/Student_Registration/Registration_Success';
import Registration_failed from './components/Student_Registration/Registration_failed';

function App() {
  // if(!localStorage.getItem('user') && window.location.pathname != '/Candidate_Login'){
  //   window.location = '/Candidate_Login';
  // }

  return (
    <div>
      <Router basename={'/v'}>
          <Routes  >
          <Route path='/' element={< CandidateLogin />}></Route>
          <Route path='/Candidate_Login' element={< CandidateLogin />}></Route>
          <Route path='/Change_password' element={< Changepassword />}></Route>
            <Route path='/Candidate_Register' element={< CandidateRegister />}></Route>
            <Route path='/Candidate_Dashboard' element={< CandidateDashboard />}></Route>
            <Route path='/Candidate_Company_list' element={< CandidateCompanylist />}></Route>
            <Route path='/Candidate_Status' element={< CandidateStatus />}></Route>
            <Route path='/Candidate_Profile' element={< CandidateProfile />}></Route>
            <Route path='/Volunteer_registration' element={< Volunteer_registration />}></Route>
            <Route path='/Volunteer_login' element={< Volunteer_login />}></Route>
            <Route path='/Searchjob_seeker' element={< Searchjob_seeker />}></Route>
            <Route path='/Report_generation' element={< Report_generation />}></Route>
            <Route path='/Edit_profile' element={< Edit_profile />}></Route>
            <Route path='/Error_Page' element={< ErrorPage />}></Route>
            
            <Route path='/skill-test' element={< Home_page />}></Route>
            <Route path='/go-to-exam' element={< Go_To_Exam />}></Route>
            <Route path='/start-exam' element={< Start_Exam />}></Route>
            <Route path='/certificate' element={< Certificate />}></Route>

            <Route path='/student-registration' element={< StudentRegistration />}></Route>
            <Route path='/registration-success' element={< Registration_Success />}></Route>
            <Route path='/registration-failed' element={< Registration_failed />}></Route>
            <Route path='/certificate-verify' element={< Validator />}></Route>
          </Routes>
    </Router>
    <NotificationContainer/> 
    <ToastContainer position="bottom-right"
         limit={1}
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" />
    </div>
  );
}

export default App;
